export interface TenantResponse {
  id: string;
  name: string;
}

export class GlobalUser {
  public firstname: string;
  public lastname: string;
  public email: string;
  public title: string;
  public language: string;
  public selfAssignedCompany: string;
  public tenant: string | TenantResponse;

  constructor(response: any) {
    this.firstname = response.firstname;
    this.lastname = response.lastname;
    this.email = response.email;
    this.title = response.title;
    this.language = response.language;
    this.selfAssignedCompany = response.selfAssignedCompany;
    this.tenant = response.tenant;
  }
}

export class User extends GlobalUser {
  public createdAt: string;
  public globalUser: string;
  public id: string;
  public role: string;
  public updatedAt: string;

  constructor(response: any) {
    super(response);
    this.createdAt = response.createdAt;
    this.globalUser = response.globalUser;
    this.id = response.id;
    this.role = response.role;
    this.updatedAt = response.updatedAt;
  }
}

export class UserInfo {
  public firstName: string;
  public lastName: string;
  public email: string;
  public role: string;
  public tenants: Array<{ tenantId: string; role: string; joinedAt?: string }>;
  public language: string;
  public tenant: string;
  public id: string;
  public createdAt: string;
  public onboardingDone: boolean;

  constructor(response: any) {
    // /users/me liefert camelCase (firstName/lastName) und `_id`; die Legacy-Namen
    // (firstname/lastname/id) bleiben als Fallback, sonst blieben Vor-/Nachname im Profil leer.
    this.firstName = response.firstName ?? response.firstname ?? '';
    this.lastName = response.lastName ?? response.lastname ?? '';
    this.email = response.email;
    this.role = response.role;
    this.tenants = response.tenants || [];
    this.language = response.language;
    this.tenant = response.tenant;
    this.id = response.id ?? response._id;
    this.createdAt = response.createdAt;
    this.onboardingDone = response.onboardingDone || false;
  }
}
